import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { ExperienceTransferListWire } from './types';
import { ExperienceTransferSearchModel } from './types-store';

export const api = {

  loadExperienceTransferList: async (
    model: ExperienceTransferSearchModel, startIndex: number, maxResults: number
  ): Promise<ExperienceTransferListWire> => {

    const response = await new RemoteAdminData(endpoints.searchExperienceTransfer)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteExperienceTransfer: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteExperienceTransfer)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
